export const TAB = '\t'
export const ENTER = '\n'
export const SPACE = ' '
